import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tj',
  templateUrl: './tj.component.html',
  styleUrls: ['./tj.component.css']
})
export class TjComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/tj/tj.component.ts